import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';

import UserSearch from '@/shared/components/input/UserSearch';

import messages from '../hrmMessages';
import { FaUndo } from 'react-icons/fa';
import DelayedDateRangePicker from '@/shared/components/input/DelayedDateRangePicker';
import moment from 'moment';

export const defaultFilters = {
  deadlineFrom: moment().startOf('year'),
  deadlineUntil: moment().endOf('year'),
};

class CapacityReportFilters extends Component {
  constructor(props) {
    super(props);
    this.state = { hasFilters: this.computeHasFilters(props.filters) };
  }

  computeHasFilters = filters => filters.employeeId || filters.employeeProfile;

  filterChanged = filter => {
    const { filters, onFilterChange } = this.props;
    const newFilters = { ...filters, ...filter };
    const hasFilters = this.computeHasFilters(newFilters);

    if (JSON.stringify(filters) !== JSON.stringify(newFilters)) {
      onFilterChange(newFilters);
    }

    this.setState({ hasFilters });
  };

  resetFilters = () => {
    this.filterChanged({ ...defaultFilters });
  };

  dateRangeChanged = (startDate, endDate) => {
    this.filterChanged({ deadlineFrom: startDate, deadlineUntil: endDate });
  };

  render() {
    const { filters, columns, intl } = this.props;
    const { hasFilters } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col-lg-4">
            <div className="form-group">
              <DelayedDateRangePicker
                startDate={filters.deadlineFrom ? moment(filters.deadlineFrom) : undefined}
                startDateId="CapacityReportFilterDeadlineFrom"
                endDate={filters.deadlineUntil ? moment(filters.deadlineUntil) : undefined}
                endDateId="CapacityReportFilterDeadlineUntil"
                onDatesChange={({ startDate, endDate }) =>
                  this.dateRangeChanged(startDate, endDate)
                }
                intl={intl}
                startDatePlaceholderText={intl.formatMessage(messages.DeadlineFrom)}
                endDatePlaceholderText={intl.formatMessage(messages.DeadlineUntil)}
              />
            </div>
          </div>
        </div>
        {hasFilters && (
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <button
                type="button"
                className="btn btn-default btn-reset"
                onClick={() => this.resetFilters()}
              >
                <FaUndo className="react-icon" />
                &nbsp;
                <FormattedMessage {...messages.ResetFilters} />
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

CapacityReportFilters.propTypes = {
  intl: intlShape.isRequired,
  filters: PropTypes.shape({
    deadlineFrom: PropTypes.string,
    deadlineUntil: PropTypes.string,
  }),
  onFilterChange: PropTypes.func.isRequired,
};

CapacityReportFilters.defaultProps = {
  filters: { ...defaultFilters },
};
export default injectIntl(CapacityReportFilters);
